<ng-container *ngIf="this._UserHelper.isSignedIn">
  <div class="mobile-page-header">
    <div class="left-side">{{ 'my_bets' | translate }} ({{ this._DataHelper.cashoutSlipsList.length }})</div>
  </div>
  <mat-accordion>
    <ng-container *ngIf="'isCashoutInfo' | getEnv">
      <div class="cashout-info-general-container" *ngIf="!this._UserHelper.customerUser.IsCashOutInfo">
        <div class="cashout-info-container">
          <span class="underline-span"> Info: </span>
          {{ 'Cashout_Info' | translate }}
          <div class="cashout-info-button-container">
            <div class="button-row" (click)="cashoutInfo()">
              <div class="infoButton">
                <div class="btn-text mobile-text" [ngClass]="this.cashoutInfoButtonState ? 'active' : ''">
                  {{ 'OK' | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngFor="let item of this._DataHelper.cashoutSlipsList; trackBy: trackBySlipId">
      <mat-expansion-panel
        class="cashout-expansion-panel mat-elevation-z0"
        [expanded]="lastSlipId === item.SlipId"
        (closed)="Cashout_ExpansionPanel_Close(item.SlipId)"
        (opened)="Cashout_ExpansionPanel_Open(item.SlipId)"
        (click)="getCashoutSlipDetail(item.SlipId)">
        <mat-expansion-panel-header class="cashout-expansion-panel-header text">
          <div class="cashout-header-container">
            <div class="slip-type">
              {{ item.SlipType }}
              <div *ngIf="item.isLive" class="live-badge">
                {{ 'LIVE' | translate }}
              </div>
              <!-- Statu Durumunu id ile yönetemediğimiz için string kontrol yapmak zorunda kaldık -->
              <div
                *ngIf="
                  item.SlipStatu !== '' && (item.SlipStatu === 'FreeBet' || item.SlipStatu === 'Bedava Bahis' || item.SlipStatu === 'Freiwette' || item.SlipStatu === 'Boost Bonus')
                "
                class="freebet-row">
                <label class="freebet-label" for="freebet">{{ item.SlipStatu }}</label>
              </div>
              <div *ngIf="item.SlipStatu.includes('Boost')" class="freebet-row">
                <image-loader-utils url="rocket" extraClasses="lugassvg"></image-loader-utils>
              </div>
            </div>
            <div>
              <span> {{ 'Possible_Winnings' | translate }} : </span>
              <span class="bold-700"> {{ item.PossibleGain | balanceFormat }}</span>
            </div>
            <div>
              <span> {{ 'Total_Stake' | translate }} : </span>
              <span class="bold-700">
                {{ item.Amount | balanceFormat }}
              </span>
            </div>
          </div>
          <div *ngIf="environment.isWildCard && item.SlipStatu !== '' && item.SlipStatu === 'Wild Card'" class="wildcard-row">
            <image-loader-utils url="wildcard" extraClasses="wildcardsvg"></image-loader-utils>
          </div>
        </mat-expansion-panel-header>
        <div class="cashout-detail-container text">
          <ng-container *ngIf="item['details'] != undefined">
            <div
              [ngClass]="{ 'selected-wildcard': checkSlipOddIdControl(cashoutItem.SlipOddId) }"
              class="cashout-detail-item"
              *ngFor="let cashoutItem of item['details'] | groupbymatchid | sortBy : false : 'EventDateIso'; trackBy: trackByMatchId">
              <div *ngIf="!cashoutItem.MatchIsActive && !isJacktimeActive" class="cashout-lock-reason">
                <div class="message">
                  <div class="reason-text">
                    {{ cashoutItem.Reason }}
                  </div>
                  <div class="lock-icon">
                    <image-loader-utils url="cashout-lock" extraClasses="lock-icon"></image-loader-utils>
                  </div>
                </div>
              </div>

              <div [ngClass]="!cashoutItem.MatchIsActive && 'blur-active'">
                <div class="team-box">
                  <div class="banko-box" *ngIf="cashoutItem.Banko == 1">
                    <div class="banko-button">B</div>
                  </div>
                  <div class="team-name" (click)="goDetail(cashoutItem)">
                    <div class="home">
                      <div
                        class="{{ cashoutItem.HomeTeamCard != 0 && cashoutItem.HomeTeamCard != undefined ? 'red-card-2' : null }}"
                        *ngIf="cashoutItem.HomeTeamCard != 0 && cashoutItem.HomeTeamCard != undefined">
                        {{ cashoutItem.HomeTeamCard }}
                      </div>
                      {{ cashoutItem.HomeTeam }}
                    </div>
                    <div class="away">
                      <div
                        class="{{ cashoutItem.AwayTeamCard != 0 && cashoutItem.AwayTeamCard != undefined ? 'red-card-2' : null }}"
                        *ngIf="cashoutItem.AwayTeamCard != 0 && cashoutItem.AwayTeamCard != undefined">
                        {{ cashoutItem.AwayTeamCard }}
                      </div>
                      {{ cashoutItem.AwayTeam }}
                    </div>
                  </div>
                  <div *ngIf="environment.isWildCard && cashoutItem.WildCardEneble" class="wildcard-clock-container">
                    <div class="wildcard-clock-row" *ngIf="wildCardStep === '' || wildCardStep === 'step1' || wildCardStep === 'step2'" (click)="handleCheckboxChange(cashoutItem)">
                      <image-loader-utils url="alarm-clock"></image-loader-utils>
                      <div>{{ cashoutItem?.WildCardTime }}</div>
                    </div>
                  </div>
                  <div class="wildcard-used-container" *ngIf="cashoutItem.IsWildCard">
                    <image-loader-utils url="wildcard_used"></image-loader-utils>
                  </div>
                  <div class="match-time">
                    <ng-container *ngIf="cashoutItem.IsLive || cashoutItem.MatchStatus === 'Beendet'">
                      {{ cashoutItem.MatchStatus }}
                    </ng-container>
                  </div>
                  <div class="team-score">
                    <div class="score">
                      {{ cashoutItem.HomeTeamScore }}
                      <ng-container *ngIf="!cashoutItem.IsLive && cashoutItem.MatchStatus !== 'Beendet'">
                        <span style="font-weight: 400; margin-left: 13px">
                          {{
                            (cashoutItem.EventDateIso | dateFormat : 'dd-MM') == (this.today | dateFormat : 'dd-MM')
                              ? ('today' | translate)
                              : (cashoutItem.EventDateIso | dateFormat : 'dd.MM')
                          }}
                        </span>
                      </ng-container>
                    </div>
                    <div class="score">
                      {{ cashoutItem.AwayTeamScore }}
                      <ng-container *ngIf="!cashoutItem.IsLive && cashoutItem.MatchStatus !== 'Beendet'">
                        <span style="font-weight: 400; margin-left: 13px">
                          {{ cashoutItem.EventDateIso | dateFormat : 'H:mm' }}
                        </span>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="odd-box" *ngFor="let oddInfo of cashoutItem.oddInfos">
                  <div class="odd-left">
                    {{ oddInfo.OddType }} {{ oddInfo.SpecialBetValue }}
                    <b>
                      {{ oddInfo.Outcome }}
                    </b>
                  </div>
                  <div class="odd-state">
                    <image-loader-utils *ngIf="oddInfo.State === 'Won'" url="check-circle" extraClasses="check-circle-icon won"></image-loader-utils>
                    <div *ngIf="oddInfo.State === 'Lost'" class="lost-badge-container">x</div>
                  </div>
                  <div class="odd-right">
                    {{ oddInfo.CustomerOddValue }}
                  </div>
                </div>

                <div class="odd-box relative" *ngIf="cashoutItem.MatchTime && cashoutItem.MatchTime !== ''">
                  <div class="odd-left">{{ 'score' | translate }} : {{ cashoutItem.MatchTime }}</div>
                </div>
              </div>
              <div class="odd-box relative" *ngIf="cashoutItem.IsLive && cashoutItem.MatchStatus !== 'Ende'">
                <ng-container *ngIf="'IsBetStopReasonCashout' | getEnv">
                  <ng-container *ngIf="this.isMobileView">
                    <div class="odd-left">
                      <betStopReason-component
                        [betStopReasonId]="cashoutItem?.BetStopReasonId"
                        [teamScore]="{ homeTeamScore: cashoutItem?.HomeTeamScore, awayTeamScore: cashoutItem?.AwayTeamScore }"
                        [homeTeamName]="cashoutItem?.HomeTeam"
                        [awayTeamName]="cashoutItem?.AwayTeam"
                        [isLive]="true"
                        page="myBets"></betStopReason-component>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="('isCashoutTracker' | getEnv) && this.isMobileView">
                  <div class="odd-right" [ngClass]="this.clickedMatchId === cashoutItem.BetradarMatchId ? 'active' : ''" (click)="openWidget(cashoutItem.BetradarMatchId)">
                    <image-loader-utils url="statium" extraClasses="statium-icon"></image-loader-utils>
                  </div>
                </ng-container>
              </div>
              <ng-container *ngIf="'isCashoutTracker' | getEnv">
                <ng-container *ngIf="clickedMatchId !== null">
                  <livetracker-component
                    *ngIf="cashoutItem.BetradarMatchId === clickedMatchId && lastSlipId === item.SlipId"
                    [showLiveList]="false"
                    [eventIdByInput]="cashoutItem.BetradarMatchId"></livetracker-component>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="item['details'] == undefined">
            <ngx-skeleton-loader [theme]="{ height: '50px', width: '100%', background: 'var(--white-color-300)' }" count="3"> </ngx-skeleton-loader>
          </ng-container>
        </div>
      </mat-expansion-panel>
      <div class="cashout-button-box">
        {{ item.MatchIsActive }}

        <div class="cashout-submit-message" *ngIf="item.cashoutSubmitMessageIsActive">
          {{ 'cashout_submit_message' | translate }}
        </div>

        <ng-container *ngIf="cashoutApproveSlipId != item.SlipId">
          <div
            class="cashout-value-button"
            *ngIf="isJacktimeActive ? item.CashOutValueJacktime > 0 && (item.CashoutValue | cashoutBalance) > 0 : (item.CashoutValue | cashoutBalance) > 0"
            (click)="cashoutApprove(item.SlipId)">
            Cashout &nbsp;<span [ngClass]="{ cashoutInitial: item.State == 0, cashoutgoUp: item.State == 1, cashoutgoDown: item.State == 2 }">{{
              isJacktimeActive ? (item.CashOutValueJacktime | balanceFormat) : (item.CashoutValue | balanceFormat)
            }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="cashoutApproveSlipId == item.SlipId">
          <div class="cashout-approve-box">
            <div
              class="cashout-value-button confirm"
              *ngIf="(isJacktimeActive ? item.CashOutValueJacktime : (item.CashoutValue | cashoutBalance)) !== 0"
              (click)="cashOut(item.SlipId, isJacktimeActive ? item.CashOutValueJacktime : item.CashoutValue)">
              {{ 'Confirm' | translate }}
            </div>

            <div class="cashout-value-button modify" *ngIf="(isJacktimeActive ? item.CashOutValueJacktime : (item.CashoutValue | cashoutBalance)) !== 0" (click)="cashoutModify()">
              {{ 'cancel' | translate }}
            </div>
          </div>
        </ng-container>
        <!-- isJacktimeActive alanı true ise CashoutValue 0 değilse kitlenecek,isJacktimeActive alanı false ise 0 ise kilitlenecek -->
        <div
          class="cashout-value-button lock"
          *ngIf="isJacktimeActive ? item.CashOutValueJacktime === 0 || (item.CashoutValue | cashoutBalance) === 0 : (item.CashoutValue | cashoutBalance) === 0">
          <image-loader-utils url="cashout-lock" extraClasses="lock-icon"></image-loader-utils>
        </div>
        <ng-container
          *ngIf="environment.isWildCard && !(item.SlipStatu === 'Wild Card') && this.lastSlipId == item.SlipId && item['details'] && checkWildCardEnebleControl(item['details'])">
          <div *ngIf="wildCardStep === '' || wildCardStep === 'cancel'" class="cashout-value-button wildcard" (click)="setWildCardStep('step1')">
            {{ 'wild_card' | translate }}
          </div>
          <div *ngIf="wildCardStep === 'step1'" class="cashout-value-button wildcard" (click)="setWildCardStep('step2')">
            {{ 'select_event' | translate }}
          </div>
          <ng-container *ngIf="wildCardStep === 'step2'">
            <div class="cashout-value-button cancel" (click)="setWildCardStep('cancel')">
              {{ 'Cancel' | translate }}
            </div>
            <div class="cashout-value-button wildcard" (click)="customerSlipWildCard()">
              {{ 'Confirm' | translate }}
            </div>
          </ng-container>
        </ng-container>
        <div *ngIf="this.isRestoreButton.includes(item.SlipId) && inputStateId == 1" (click)="slipRestorep1001(item.SlipId)" class="restore-slip-box">
          <image-loader-utils url="rotate" extraClasses="rotate-icon"></image-loader-utils>
          <div class="restore-slip-text">{{ 'slipdetail_re_use_slip' | translate }}</div>
        </div>
        <div class="bet-slips-detail-text" *ngIf="lastSlipId === item.SlipId">
          <span [routerLink]="['/account/bet-slip', item.SlipId]">#{{ item.SlipId }}</span>
          <span [routerLink]="['/account/bet-slip', item.SlipId]">{{ 'BETTING_SLIP_DETAILS' | translate }}</span>
        </div>
        <!-- <div class="show-all-button-container">
          <div class="show-all-button">
            {{ 'show_all' | translate }}
          </div>
        </div> -->
      </div>
    </ng-container>
  </mat-accordion>

  <mat-card class="attention-card" *ngIf="this._DataHelper.cashoutSlipsList.length == 0">{{ 'Cashout_Length_Zero' | translate }}</mat-card>
</ng-container>
